// extracted by mini-css-extract-plugin
module.exports = {"presets":"styles_presets__3sUtI"};